import React, { useState } from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

import { AuthLayout } from "src/layouts/AuthLayout";
import { useTranslation } from "react-i18next";
import { usePasswordResetConfirmMutation } from "src/hooks/usePasswordResetConfirmMutation";
import { PasswordResetConfirmForm, type PasswordResetConfirmFormData } from "src/forms/PasswordResetConfirmForm";
import { useRequiredURLSearchParam } from "src/hooks/useRequiredURLSearchParam";

export function PasswordResetConfirmPage(props: {}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const token = useRequiredURLSearchParam("token", "/");

  // for this simple state, useState is sufficient, when state becomes a little more complex, think about xstate.
  const [isFinished, setIsFinish] = useState(false);

  const passwordResetConfirmMutation = usePasswordResetConfirmMutation(token);

  function handleClose() {
    navigate("/login");
  }

  function handleSubmit(values: PasswordResetConfirmFormData) {
    passwordResetConfirmMutation.mutateAsync(values.password).then(() => {
      setIsFinish(true);
    });
  }

  return render();

  function render() {
    return (
      <AuthLayout>
        <StyledBox height="100%" display="flex" flexDirection="column" justifyContent="center">
          {!isFinished && renderForm()}
          {isFinished && renderFinished()}
        </StyledBox>
      </AuthLayout>
    );
  }

  function renderForm() {
    return (
      <>
        <Box pb={3}>
          <Typography variant="h3" component="h1">
            {t("label.resetYourPassword")}
          </Typography>
          <Typography variant="subtitle1" component="h1">
            {t("label.chooseANewPassword")}
          </Typography>
        </Box>
        <PasswordResetConfirmForm
          onClose={handleClose}
          onSubmit={handleSubmit}
          errors={passwordResetConfirmMutation.error}
          isLoading={passwordResetConfirmMutation.isLoading}
        />
        {/* <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={async (values, actions) => {
            setServerErrors([]);

            const result = await password.confirm(token, values.password);

            if (result.isOk()) {
              setIsFinish(true);
            } else {
              const error = result.error.shift();
              if (error) {
                enqueueSnackbar(parseServerError(error), {
                  variant: "error",
                });
              }
            }
          }}
        >
          {({ isSubmitting, handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    component={TextField}
                    label={t("label.password")}
                    name="password"
                    type="password"
                  />
                </Grid>

                <Grid item xs={12}>
                  <Field
                    component={TextField}
                    label={t("label.passwordConfirmation")}
                    name="passwordConfirmation"
                    type="password"
                  />
                </Grid>

                <Grid item xs={12}>
                  <ServerErrors data={serverErrors} />
                </Grid>
              </Grid>

              <ButtonGrid container item xs={12} justify="flex-start">
                <ButtonLoading type="submit" isLoading={isSubmitting}>
                  {t("label.submit")}
                </ButtonLoading>

                <Button
                  variant="text"
                  disabled={isSubmitting}
                  onClick={handleCancel}
                >
                  {t("label.cancel")}
                </Button>
              </ButtonGrid>
            </Form>
          )}
        </Formik> */}
      </>
    );
  }
  function renderFinished() {
    return (
      <>
        <Box pb={3}>
          <Typography variant="h3" component="h1">
            {t("label.yourPasswordHasBeenChanged")}
          </Typography>
          <Typography variant="subtitle1" component="h1">
            {t("label.youCanLoginWithYourNewCredentials")}
          </Typography>
        </Box>
        <Grid container>
          <Button color="primary" variant="contained" onClick={() => navigate("/login")}>
            {t("label.login")}
          </Button>
        </Grid>
      </>
    );
  }
}

const StyledBox = styled(Box)`
  padding: ${({ theme }) => theme.spacing(8)};
  width: fit-content;
`;
